export function removeEmptyPreviewColumns(rows:string[][]){
  const columnCount=Math.max(0,...rows.map(row=>row.length));
  const visibleColumns=Array.from({length:columnCount},(_,index)=>index)
    .filter(index=>rows.some(row=>String(row[index]??"").trim()!==""));
  return rows.map(row=>visibleColumns.map(index=>row[index]??""));
}
